import { z } from 'zod';
import { zDbId } from '~/plugins/zod/utils';
import { CategoryItemDetailSchema, CategorySimpleSchema } from '../links/_types';

export const CategoryTreeItemInfoSchema: z.ZodType<CategoryTreeItemInfo> = CategorySimpleSchema.extend({
    Children: z.lazy(() => CategoryTreeItemInfoSchema.array()),
});

export const CategoryTreeInfoSchema = z.object({
    Categories: CategoryTreeItemInfoSchema.array(),
    Sale: CategoryTreeItemInfoSchema.array(),
});

export const CategoryDetailSchema = z.object({
    Id: zDbId(),
    Name: z.string(),
    FullName: z.string().array(),
    Items: CategoryItemDetailSchema.array(),
});

export type CategorySimple = z.infer<typeof CategorySimpleSchema>;
export type CategoryDetail = z.infer<typeof CategoryDetailSchema>;
export type CategoryTreeItemInfo = z.infer<typeof CategorySimpleSchema> & {
    Children: CategoryTreeItemInfo[];
};
export type CategoryTreeInfo = z.infer<typeof CategoryTreeInfoSchema>;

export interface CategoryTreeItem {
    Id: number;
    TreeId: string;
    Name: string;
    IsDiscount: boolean;
    Children: CategoryTreeItem[];
}

export type CategoryTree = CategoryTreeItem[];
